<template>
  <div class="BaseTemplateItemShapeSetting">
    <h2 class="q-mt-none q-mb-md text-cool-gray-100 fs-17px fw-500 text-capitalize">
      {{ t('contents.shapes.setting_title') }}
    </h2>

    <k-divider class="q-my-md" size="md" color="cool-gray-40" />

    <BaseTemplateItemTransformSetting />

    <template v-if="!templateStore.isPrintTemplate">
      <k-divider class="q-my-md" dotted size="sm" color="cool-gray-50" />

      <div class="flex items-center justify-between">
        <p class="q-mb-none fw-500 fs-15px text-cool-gray-80">{{ t('contents.styles.select_shape_colour') }}</p>
        <span class="flex">
          <k-icon class="cursor-pointer" name="colours" size="24px" />

          <q-popup-proxy ref="colorPickerPopup">
            <k-colour-picker
              style="width: 290px"
              :model-value="templateStore.activeItem.colour"
              :done-label="globalT('save')"
              :cancel-label="globalT('cancel')"
              @cancel="$refs.colorPickerPopup.hide()"
              @update:model-value="templateStore.handleUpdateItemSetting('colour', $event)"
            />
          </q-popup-proxy>
        </span>
      </div>
    </template>

    <div v-if="isLine">
      <k-divider class="q-my-md" dotted size="sm" color="cool-gray-50" />
      <div
        v-for="variant in lineVariants"
        :key="variant"
        class="BaseTemplateItemShapeSetting__line-variant transition rounded-8 flex items-center justify-between gap-56 q-mb-md q-py-xs q-px-sm cursor-pointer"
        :class="{
          'bg-teal-white-20': templateStore.activeItem.variant === variant,
        }"
        @click="templateStore.handleUpdateItemSetting('variant', variant)"
      >
        <div :style="[`border-bottom: 2px ${variant} #A9B7C3`]" class="flex-1"></div>
        <k-checkbox :model-value="templateStore.activeItem.variant === variant" :value="variant" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useTemplateStore } from 'src/stores'
import BaseTemplateItemTransformSetting from './BaseTemplateItemTransformSetting'
import translate from 'src/common/helpers/language/translate'
import translationObject from '../../translate/baseTemplate.translate'
import globalTranslateObject from 'src/translate/global.translate'

defineOptions({ name: 'BaseTemplateItemShapeSetting' })

const templateStore = useTemplateStore()
const { t } = translate(translationObject)
const { t: globalT } = translate(globalTranslateObject)

const isLine = computed(() => templateStore.activeItem.value === 'line')

const lineVariants = ['solid', 'dashed', 'dotted']
</script>

<style lang="sass" scoped>
@import "src/shared/styles/mixins.sass"

.BaseTemplateItemShapeSetting
  @include element('line-variant')
    &:hover
      background-color: var(--teal-white-20)
</style>
